export enum LanguageEvent {
    SetCachedLanguageAsSelectedLanguageOnInit = 'LanguageEvent.SetCachedLanguageAsSelectedLanguageOnInit',
    SetUserLanguageAsCachedLanguageOnInit = 'LanguageEvent.SetUserLanguageAsCachedLanguageOnInit',
    ProfileMenuLanguageClicked = 'LanguageEvent.ProfileMenuLanguageClicked',
}

type SetCachedLanguageAsSelectedLanguageOnInitPayload = {
    isSettingUserLanguage: boolean;
    cachedLanguage: string;
};

type SetUserLanguageAsCachedLanguageOnInitPayload = {
    userLanguage: string;
};

type ProfileMenuLanguageClickedPayload = {
    language: string;
};

export interface LanguageEventMap {
    [LanguageEvent.SetCachedLanguageAsSelectedLanguageOnInit]: SetCachedLanguageAsSelectedLanguageOnInitPayload;
    [LanguageEvent.SetUserLanguageAsCachedLanguageOnInit]: SetUserLanguageAsCachedLanguageOnInitPayload;
    [LanguageEvent.ProfileMenuLanguageClicked]: ProfileMenuLanguageClickedPayload;
}
